import { useState } from 'react'

import useViewGroups from '../useViewGroups/useViewGroups'

const useManageVisibilityDrawer = ({ storeId, merchantId, selectedView, saveView, canShareViewsWithAllGroups }) => {
  const [view, setView] = useState(null)
  const [show, setShow] = useState(false)
  const { groups, ownGroupIds, fetchingUserGroups, loadGroups } = useViewGroups({
    storeId,
    merchantId,
    canShareViewsWithAllGroups,
  })

  const openManageVisibilityDrawer = () => {
    setView(selectedView)
    setShow(true)
    loadGroups()
  }

  const closeManageVisibilityDrawer = () => setShow(false)

  const handleSaveVisibility = async sharedWithGroups => {
    await saveView({ name: view.name, filters: view.filters, sharedWithGroups })
    setShow(false)
  }

  return {
    showManageVisibilityDrawer: show,
    view,
    groups,
    ownGroupIds,
    fetchingUserGroups,
    openManageVisibilityDrawer,
    closeManageVisibilityDrawer,
    handleSaveVisibility,
  }
}

export default useManageVisibilityDrawer
